import React from "react";
import { Link } from "react-router-dom";

export default function WorkforceSection({ api }) {
  const track = "workforce";
  const t = api?.t || {};
  const lang = api?.lang || "en";
  const cfg = t?.programTracks?.workforce || {};

  const returnTo = "/?noIntro=1#workforce-intake";

  const heading = cfg.heading || "Workforce Development & Career Pathways";
  const startIntake = cfg.startIntake || "Start intake";
  const blurb = cfg.blurb || "Need a better job, a new skill, or a faster path into work? WOW50/50 helps you build a skills-first plan and connects you to training, employer matching, and real next steps — without requiring a traditional degree.";
  const helpTitle = cfg.helpTitle || "How we can help";
  const helpBullets = Array.isArray(cfg.helpBullets) && cfg.helpBullets.length ? cfg.helpBullets : ["Skills training (digital, admin, IT, marketplace operations).", "Skills-first pathways (STARs / competency-based progress) to qualify faster.", "Job placement support + employer matching (referrals, warm introductions).", "Upskilling support for re-entry and career changes.", "Outcome tracking (enrollments, completions, placements) to keep programs accountable."];
  const trackLabel = cfg.trackLabel || "Workforce Development";
  const partnersTitle = cfg.partnersTitle || "For employers & workforce partners";
  const partnersBody1 = cfg.partnersBody1 || "We support skills-based hiring pipelines: intake, screening, training referrals, placement support, and outcome reporting.";
  const partnersBody2 = cfg.partnersBody2 || "Partner with WOW50/50 to expand your talent pipeline and deliver measurable results.";

  const options = Array.isArray(cfg.options) && cfg.options.length
    ? cfg.options
    : [
        { id: "skills-training", label: "Skills training / upskilling" },
                { id: "employment", label: "Job placement / employer matching" },
                { id: "re-entry", label: "Re-entry / second chance support" },
                { id: "certs", label: "Industry cert guidance" },
                { id: "partnerships", label: "Employer / training partner" }
      ];

  return (
    <section id="workforce" className="scroll-mt-24 space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
          {heading}
        </h2>

        <Link
          to={`/intake?track=${encodeURIComponent(track)}&return=${encodeURIComponent(returnTo)}&lang=${encodeURIComponent(lang)}`}
          className="ml-auto inline-flex items-center justify-center rounded-full border border-emerald-400/30 bg-emerald-500/10 px-4 py-2 text-sm font-semibold text-emerald-200 hover:bg-emerald-500/15 transition"
        >
          {startIntake}
        </Link>
      </div>

      <div className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-6 space-y-4">
        <p className="text-sm sm:text-base text-slate-200 max-w-4xl">
          {blurb}
        </p>

        <div className="grid gap-3 md:grid-cols-2">
          <div id="workforce-intake" className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
            <div className="text-sm font-semibold text-slate-100">{helpTitle}</div>
            <ul className="mt-2 list-disc pl-5 text-sm text-slate-200 space-y-1">
              {helpBullets.map((b, idx) => (
                <li key={idx}>{b}</li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
            <div className="text-sm font-semibold text-slate-100">{partnersTitle}</div>
            <div className="mt-2 text-sm text-slate-200 space-y-2">
              <p>{partnersBody1}</p>
              <p>{partnersBody2}</p>
            </div>
          </div>
        </div>
      </div>
    
      <div className="mt-6 rounded-2xl border border-slate-800 bg-[#010916]/70 p-4">
        <div className="text-sm font-semibold text-slate-100">Member Intake (required)</div>
        <p className="mt-1 text-xs text-slate-300">
          To request personalized support under this program, you must be an active WOW50/50 member and logged in.
        </p>
        <div className="mt-3">
          <Link
            to={"/intake?track=" + encodeURIComponent(track)}
            className="inline-flex items-center justify-center rounded-xl border border-cyan-400/40 bg-cyan-500/10 px-4 py-2 text-sm font-semibold text-cyan-200 hover:bg-cyan-500/15"
          >
            Go to Member Intake
          </Link>
        </div>
      </div>
</section>
  );
}
